import {
  onlyInternal,
  requiresAuth,
  requiresTerms,
  hasInternalPermissionCanManageOrganizations,
  hasInternalPermissionCanManageOrders,
  hasInternalPermissionCanPlaceInternalOrder
} from "@/middleware";

const InternalView = () => import("./InternalView.vue");
const InternalCreateOrganizationView = () => import("./InternalCreateOrganizationView.vue");
const InternalOrganizationsView = () => import("./InternalOrganizationsView.vue");
const InternalOrganizationDetailsView = () => import("./InternalOrganizationDetailsView.vue");
const InternalGroupTreeView = () => import("./InternalGroupTreeView.vue");
const InternalGroupMoveView = () => import("./InternalGroupMoveView.vue");
const InternalOrdersView = () => import("./InternalOrdersView.vue");
const InternalOrderDetailsView = () => import("./InternalOrderDetailsView.vue");
const InternalCheckoutView = () => import("./InternalCheckoutView.vue");

const internalRoutes = [
  {
    path: "/internal",
    name: "Internal",
    component: InternalView,
    meta: {
      middleware: [requiresAuth, requiresTerms, onlyInternal]
    },
    redirect: () => {
      return { name: "InternalCreateOrganization" };
    },
    children: [
      {
        path: "create-organization",
        name: "InternalCreateOrganization",
        component: InternalCreateOrganizationView
      }
    ]
  },
  {
    path: "/internal/organizations",
    name: "InternalOrganizationsView",
    component: InternalOrganizationsView,
    props: true,
    meta: {
      middleware: [
        requiresAuth,
        requiresTerms,
        onlyInternal,
        hasInternalPermissionCanManageOrganizations
      ]
    }
  },
  {
    path: "/internal/organizations/:id",
    name: "InternalOrganizationDetailsView",
    component: InternalOrganizationDetailsView,
    props: true,
    meta: {
      middleware: [
        requiresAuth,
        requiresTerms,
        onlyInternal,
        hasInternalPermissionCanManageOrganizations
      ]
    }
  },
  {
    path: "/internal/organizations/:id/tree",
    name: "InternalGroupTreeView",
    component: InternalGroupTreeView,
    props: true,
    meta: {
      middleware: [
        requiresAuth,
        requiresTerms,
        onlyInternal,
        hasInternalPermissionCanManageOrganizations
      ]
    }
  },
  {
    path: "/internal/organizations/:orgId/move/:groupId",
    name: "InternalGroupMoveView",
    component: InternalGroupMoveView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, onlyInternal]
    }
  },
  {
    path: "/internal/orders",
    name: "InternalOrdersView",
    component: InternalOrdersView,
    props: true,
    meta: {
      middleware: [requiresAuth, onlyInternal, hasInternalPermissionCanManageOrders]
    }
  },
  {
    path: "/internal/orders/:id",
    name: "InternalOrderDetailsView",
    component: InternalOrderDetailsView,
    props: true,
    meta: {
      middleware: [requiresAuth, onlyInternal, hasInternalPermissionCanManageOrders]
    }
  },
  {
    path: "/internal/checkout",
    name: "InternalCheckoutView",
    component: InternalCheckoutView,
    props: true,
    meta: {
      middleware: [requiresAuth, onlyInternal, hasInternalPermissionCanPlaceInternalOrder]
    }
  }
];

export default internalRoutes;
